import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MS_PER_DAY } from "configs/constant";
import dayjs from "dayjs";
import { Field, Formik } from "formik";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { createSchedule } from "../../../../utils/action";
import {
  InputDate,
  InputSelect,
  setTitleCase,
} from "../../../components/template/partials";

// inital values form
const initialValues = {
  start_date: null,
  end_date: null,
  times: [],
  exception_dates: [],
};

// form field validation schema
const validationSchema = Yup.object().shape({
  // start_date: Yup.string().required("Tanggal Mulai wajib diisi!"),
  // end_date: Yup.string().required("Tanggal Berakhir wajib diisi!"),
  // times: Yup.array()
  //   .min(1, "Tanggal Berakhir wajib diisi!")
  //   .required("Tanggal Berakhir wajib diisi!"),
});

export function AddQuotaSchedule() {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const [isLoading, setLoading] = useState(false);
  const showDialog = location.state?.showDialog ?? false;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const getDatesInRange = (startDate, endDate) => {
    const endDateAddOneDay = new Date(endDate.setDate(endDate.getDate() + 1));
    const diffTime = Math.abs(endDateAddOneDay - startDate);
    const diffDays = Math.ceil(diffTime / MS_PER_DAY);

    const dates = [];
    for (let index = 0; index < diffDays; index++) {
      const startDateTime = new Date(startDate.getTime());
      const date = new Date(
        startDateTime.setDate(startDateTime.getDate() + index)
      );
      if (date < endDateAddOneDay) {
        dates.push(date);
      }
    }
    return dates;
  };

  const onHide = () => {
    navigate(-1);
  };

  const handleFormSubmit = async (values) => {
    const request = [];

    const datesInRange = getDatesInRange(
      new Date(values.start_date),
      new Date(values.end_date)
    );
    values.times.forEach((item_time) => {
      datesInRange.forEach((item_date) => {
        const date = dayjs(item_date);
        const time = item_time.value;
        const dateTime = dayjs(`${date.format("YYYY-MM-DD")} ${time}`);
        const bookingTime = {
          waktu_booking: dateTime.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        };
        request.push(bookingTime);
      });
    });
    // send to backend
    try {
      await createSchedule(request);
      toast.success(setTitleCase("berhasil menambahkan kuota jadwal"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  const optionsTimes = [
    {
      label: "09:00",
      value: "09:00",
    },
    {
      label: "13:00",
      value: "13:00",
    },
  ];

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-create-schedule-title"
    >
      <DialogTitle id="responsive-dialog-create-schedule-title">
        Tambah Kuota Jadwal
      </DialogTitle>
      <Divider />
      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputDate}
                    name="start_date"
                    label="Tanggal Mulai"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                    maxDate={values.end_date}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputDate}
                    name="end_date"
                    label="Tanggal Berakhir"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                    minDate={values.start_date}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputSelect}
                    options={optionsTimes}
                    getOptionLabel={(option) => option?.label ?? ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    name="times"
                    label="Pilih Waktu"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                    multiple
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                autoFocus
                onClick={onHide}
                color="error"
                variant="contained"
              >
                Batal
              </Button>
              <LoadingButton
                autoFocus
                loading={isLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Simpan
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
